export default "__VITE_ASSET__DsIzoBPD__"